import { create } from 'zustand';

interface DocumentsState {
  // Search and filters
  search: string;
  categoryFilter: string;
}

interface DocumentsActions {
  setSearch: (search: string) => void;
  setCategoryFilter: (filter: string) => void;
  resetAll: () => void;
}

type DocumentsStore = DocumentsState & DocumentsActions;

const initialState: DocumentsState = {
  search: '',
  categoryFilter: 'all',
};

export const useDocumentsStore = create<DocumentsStore>()((set) => ({
  ...initialState,

  setSearch: (search) => set({ search }),
  setCategoryFilter: (categoryFilter) => set({ categoryFilter }),
  resetAll: () => set(initialState),
}));
